import {useRef, useState} from "react";
import {useServices} from "../../../react-hooks/use-services.hook";
import {InfoBubbleTooltipContentBox} from "../../info-bubble-tooltip/boxes/info-bubble-tooltip-content.box";
import {bottom, top} from "@popperjs/core";
import {InfoBubbleTooltipTrigerBox} from "../../info-bubble-tooltip/boxes/info-bubble-tooltip-triger.box";
import styled from "styled-components";
import {ShowcaseConfigurationBox} from "../boxes/showcase-configuration/showcase-configuration.box";
import {ShowcaseContentContainerBox} from "../boxes/showcase-content-container/showcase-content-container.box";
import {Label} from "../boxes/label";


const InfoBubbleTooltipContainerBox = styled.div`
    max-width: 290px;
`;

const BASE_BUBBLE_TOOLTIP_OPTIONS = {
    content: `You can login faster using the touch / face ID features on your device.`,
    placement: top,
};


export const BubbleTooltipShowcase: React.FC = () => {
    const [bubbleTooltipOptions, setBubbleTooltipOptions] = useState(BASE_BUBBLE_TOOLTIP_OPTIONS);
    const services = useServices();
    const infoBubbleTriggerRef = useRef();


    const onChangeInput = (ev) => {
        const value = ev.target.type === 'checkbox' ? ev.target.checked : ev.target.value;
        const field = ev.target.name;
        setBubbleTooltipOptions({...bubbleTooltipOptions, [field]: value});
    }


    const showBubbleTooltip = () => {
        services.regularTooltips.showBubbleTooltip({
            ...bubbleTooltipOptions,
            renderContent: () => <InfoBubbleTooltipContentBox>{bubbleTooltipOptions.content}</InfoBubbleTooltipContentBox>,
            attachTo: infoBubbleTriggerRef?.current
        });
    };

    return (
        <>
            <ShowcaseContentContainerBox>
                <ShowcaseConfigurationBox>
                    <h3>text:</h3>
                    <input type="text" value={bubbleTooltipOptions.content} name="content" onChange={onChangeInput} />
                </ShowcaseConfigurationBox>

                <ShowcaseConfigurationBox>
                    <h3>placement:</h3>
                    <div>
                        {[top, bottom].map((placementVarient) =>
                            <div key={placementVarient}>
                                <input
                                    type="radio" name="placement" id={"placementVarient" + placementVarient}
                                    value={placementVarient} checked={bubbleTooltipOptions.placement === placementVarient}
                                    onChange={onChangeInput}
                                />
                                <Label htmlFor={"placementVarient" + placementVarient}>{placementVarient}</Label>
                            </div>
                        )}
                    </div>
                </ShowcaseConfigurationBox>
            </ShowcaseContentContainerBox>

            <InfoBubbleTooltipContainerBox>
                    <span>Click to popup bubble tooltip: </span>
                    <InfoBubbleTooltipTrigerBox
                        src={services.theme.currentTheme.assets.images.letter_info_bubble_svg.toString()}
                        onClick={showBubbleTooltip}
                        ref={infoBubbleTriggerRef}
                    />
            </InfoBubbleTooltipContainerBox>
        </>
    );
}